export default __webpack_public_path__ + "static/ecology-1a62355d988470e5e72b99bc5f288d0c.svg";